import gql from 'graphql-tag'
import BaseDataTable from '@/components/BaseDataTable'

export const COMPANY_RECRUITER_FRAGMENT = gql`
  fragment CompanyRecruiterFragment on CompanyRecruiter {
    id
    status
    email
    recruiterFee
    recruiterOwnershipDays
    recruiterOwnershipDaysLeft
    recruiterManagesWorkers
    hasHires
    recruiter {
      id
      name
      avatar
    }
    tags {
      id
      name
    }
  }
`

export const CompanyRecruiters = gql`
  query companyRecruiters($accounts: [ID!], $page: Int, $perPage: Int) {
    companyRecruiters(accounts: $accounts, page: $page, first: $perPage) {
      data {
        ...CompanyRecruiterFragment
      }
      paginatorInfo {
        ...PaginatorInfoFragment
      }
    }
  }
  ${COMPANY_RECRUITER_FRAGMENT}
  ${BaseDataTable.fragments.pagination}
`
